import type { ReactNode } from 'react';
import styles from './style.module.css';

export function ChartCard({ title, unit, children }: { title: string; unit?: string; children: ReactNode }) {
  return (
    <div className={styles.card}>
      <div className={styles.title}>
        <span>{title}</span>
        {unit && <span className={styles.unit}>{unit}</span>}
      </div>
      <div className={styles.body}>{children}</div>
    </div>
  );
}
